import React, { useState, useEffect } from 'react';
import maleImg from '../../images/male.png';
import femaleImg from '../../images/female.png';


const CampaignGenderChart = props => (
  <div div className="CampaignDonutChart">
    <h2>Gender</h2>
    <div className="CampaignBarChart_more-info" onClick={()=>props.closeModal(true)}>More info</div>

    <div className="CampaignIncomeChart_container">

      <div className="CampaignIncomeChart_content-block" >
        <div className="CampaignIncomeChart_image" style={{padding: '15px'}}>
          <img src={maleImg} style={{width: '158px' ,height: '169px'}}/>
        </div>
        <div className="CampaignIncomeChart_title">
          Male
        </div>
        <div className="CampaignIncomeChart_dolor-value">
          55%
        </div>
      </div>

      <div className="CampaignIncomeChart_content-block">
        <div className="CampaignIncomeChart_image" style={{padding: '15px'}}>
          <img src={femaleImg} style={{width: '158px'}}/>
        </div>
        <div className="CampaignIncomeChart_title">
          Female
        </div>
        <div className="CampaignIncomeChart_dolor-value">
          45%
        </div>
      </div>

    </div>
  </div>
);

export default CampaignGenderChart;
